// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import AboutUsMain from "./AboutUsMain";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {agency?.agencyName || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.pageTitle')} isSeo={true} />

            <div id="page" className="about-us-page">
                <section className="space-ptb">
                    <div className="container-fluid">
                        <div className="row align-items-start">
                            <div className="col-12 mb-4 mb-lg-0">
                                <AboutUsMain />
                            </div>
                            {/* Colonna Sidebar (Widgets) */}
                            <div className="col-12">
                                {showAgents && agentsError && (
                                    <div className="alert alert-danger">{t('aboutUsPage.agentsError', 'Errore nel caricamento degli agenti.')}</div>
                                )}
                                <AgentsSection
                                    showAgents={showAgents}
                                    agents={agents}
                                    agentsLoading={agentsLoading}
                                    agentsError={agentsError}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};
export default AboutUs;